import { User } from '../models';
import { ModelResource } from './resource';
import type { UserAssignmentStats } from '@api/models/user';

export class Users extends ModelResource<User> {
  model = User;

  resourcePath = 'v1/users';

  async grantAccess(userId: string, user?: User): Promise<User> {
    if (user && user.id !== userId) {
      throw Error(`${userId} does not match provided user with id ${user.id}`);
    }

    return this.api.post(this.path(userId, 'grant-access')).then((response) => {
      if (user) {
        user.updateFromJson(response.data);
        return user;
      }

      return User.fromJson(response.data);
    });
  }

  /** @deprecated Use `sdk.users.updateUserRole` (v2) instead. */
  async updateRole(userId: string, isAdmin: boolean, user?: User): Promise<User> {
    if (user && user.id !== userId) {
      throw Error(`${userId} does not match provided user with id ${user.id}`);
    }

    return this.api
      .post(this.path(userId, 'role'), { data: { is_org_admin: isAdmin } })
      .then((response) => {
        if (user) {
          user.updateFromJson(response.data);
          return user;
        }

        return User.fromJson(response.data);
      });
  }

  async deactivate(userId: string, reassignTo?: string, user?: User): Promise<User> {
    if (user && user.id !== userId) {
      throw Error(`${userId} does not match provided user with id ${user.id}`);
    }

    return this.api
      .post(this.path(userId, 'deactivate'), {
        data: { reassign_to: reassignTo ?? null },
      })
      .then((response) => {
        if (user) {
          user.updateFromJson(response.data);
          return user;
        }

        return User.fromJson(response.data);
      });
  }

  async getAssignmentStats(userId: string): Promise<UserAssignmentStats> {
    return this.api.get(this.path(userId, 'assignment-stats'), {}).then((response) => {
      return response.data;
    });
  }

  async completeOnboarding(userId: string, user?: User): Promise<User> {
    if (user && user.id !== userId) {
      throw Error(`${userId} does not match provided user with id ${user.id}`);
    }

    return this.api.post(this.path(userId, 'complete_onboarding')).then((response) => {
      if (user) {
        user.updateFromJson(response.data);
        return user;
      }

      return User.fromJson(response.data);
    });
  }
}
